/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 视频
 */
'use strict';
angular.module('editVideoModule', ['editVideoRouterModule']).controller('editVideoCtrl', [
    '$scope',
    '$element',
    '$stateParams',
    '$q',
    '$compile',
    '$state',
    'httpService',
    'modalDialog',
    'ueditorService',
    '$validation',
    'localStorageService',
    '$timeout',
    '$sce',
    '$interval',
    'playVideoService',
    'editPictureService',
    'persinalLibraryService',
    function ($scope, $element, $stateParams, $q, $compile, $state, httpService, modalDialog, ueditorService, $validation, localStorageService, $timeout, $sce, $interval, playVideoService, editPictureService, persinalLibraryService) {
        initStatus();
        initData();
        /**
         * [initStatus description] 初始化参数
         */
        function initStatus() {
            $scope.srcVideo = '';
            $scope.status = {
                videoIds: [], //视屏数据的集合
                progress: '0', //上传进度
                libType_v: 101, //video的libType
                uploading: false, // 是否正在上传
                uploadSuccess: false, //视频是否上传成功
                uploadError: false, //视频是否上传失败
                // transcoding: false, //视频正在转码
                // transcodSuccess: false, //视屏是否转码成功
                // transcodError: false, //视频是否转码失败
                videoUrl: '', //视屏的播放地址
                videoImageUrl: '', //视频播放图片的地址
                isBackstage: false, //区分后台和前台
                timer: null,
                complete: 100, // 上传完成
                unit: 1024, // 单位
                burst: 5, // 分片
                division: 20, // 分片间隔数，超过该数认为是大视频
                uploadNum: 0,
            };
            $scope.list = {
                id: 0,
                articleTitle: '',
                articleChannel: 0,
                articleHtmlCon: '',
                articleStatus: '',
                firstClassId: '',
                secondClassId: '',
                // articleStatus: '',
                remark: '',
                yunshiIds: []
            };
            $scope.onuploadList = []; // 要上传的视频集合
            // $scope.uploadListCache = [];
            $scope.uploader = {
                example: '',
                canNotPlay: false, // video标签只能播放MP4、WebM、Ogg的格式
                progress: 0,
                // fastVideoTimer: '',
                // fastVideoInfo: {}, // 视频快编信息
                // speed: '0KB/S', // 上传速率
                // surplusTime: '', // 剩余时间
                uploaderOptions: {
                    showModal: false, // 是否展示弹窗
                    auto: true, // 自动上传
                    multiple: true,
                    accept: {
                        title: '视频',
                        extensions: 'mp4,mov,mpeg,avi',
                        mimeTypes: 'video/mp4,video/mpeg,video/x-msvideo,video/quicktime'
                    },
                    // fileSizeLimit: 1 * 1024 * 1024,
                    fileSingleSizeLimit: 300 * 1024 * 1024,
                } // 上传配置项
            };
            $scope.data = {};
            // loadUploadIframe();
        }

        function initData() {
            getClassicListOneLevel()
                .then(function () {
                    return getClassicListTwoLevel();
                })
                .then(() =>
                    getPubWayInfo()
                        .then(function () {
                            return initList();
                        })
                        .then(function () {
                            loadUeditor();
                            reSelectClassify();
                        })
                );
        }
        /**
         * [uploadVideo description]初始化上传至吉木萨尔县在线的视频的方法
         * @return {[type]} [description]
         */
        $scope.uploadVideo = function () {
            uploadVideo();
        };

        /**
         * [uploadVideo description]视频上传
         * @return {[type]} [description]
         */

        function uploadVideo() {
            var upload = $scope.uploader.example();
            $scope.uploadObj = upload;
            $scope.uploader.canNotPlay = false;
            upload.on('success', function (file) {
                $scope.status.transcoding = true;
                registerVideo(file).then(videoInfo => {
                    if (file.type !== 'video/mp4') {
                        $scope.uploader.canNotPlay = true;
                    }
                    if (file.path && file.path.split('?').length) {
                        $scope.status.videoUrl = file.path.split('?')[0];
                    }
                    else {
                        $scope.status.videoUrl = file.path;
                    }
                    $scope.status.uploadSuccess = true;
                    $scope.status.uploadError = false; //视频是否上传失败
                    // $scope.status.transcoding = false; //视频正在转码
                    // $scope.status.transcodSuccess = true;
                    $scope.status.uploading = false; // 正在上传结束
                    $timeout(function () {
                        $scope.list.yunshiIds = [];
                        $scope.list.yunshiIds.push(
                            {
                                type: 3,
                                originName: file.fileName,
                                uploadName: file.name,
                                uploadPath: $scope.status.videoUrl,
                                thumbImg: videoInfo.datas.ThumbImg,
                                audioVideoId: videoInfo.datas.videoid
                            }
                        );
                        $scope.list.yunshiIds = JSON.stringify($scope.list.yunshiIds);
                    });
                });
            });
            upload.on('progress', function (obj) {
                for (let i = 0; i < $scope.onuploadList.length; i++) {
                    if ($scope.onuploadList[i].id === obj.id) {
                        $scope.status.progress = obj.progress.toFixed(2);
                        $scope.status.speed = obj.speed;
                        if (obj.file.status === '等待上传中') {
                            $scope.status.status = '正在上传中...';
                            $scope.status.canSaveMaterial = false;
                        }
                        if (obj.progress === $scope.status.complete) {
                            $scope.status.status = '正在校验中...';
                            $scope.status.canSaveMaterial = false;
                        }
                        $scope.status.uploadError = false; //视频是否上传失败
                        $scope.status.transcoding = true; //视频正在转码
                        break;
                    }
                }
            });
            upload.on('fail', function (info) {
                $scope.uploader.progress = '0';
                $scope.status.uploadSuccess = false;
                $scope.status.uploadError = true; //视频是否上传失败
                $scope.status.transcoding = false; //视频正在转码
                $scope.status.uploading = false; // 正在上传结束
                $scope.deletevideo(info);
            });
            // 上传文件的时候传过来进行分片计算是否展示需要进行文件校验等待
            upload.on('queued', function (file) {
                let fileName = angular.copy(file.file.name);
                $scope.status.uploadNum++;
                file.file.fileName = fileName.substring(0, fileName.lastIndexOf('.'));
                $scope.onuploadList.push(file.file);
                $scope.status.uploading = true; // 正在上传
                $scope.status.status = '等待上传中';
                // $scope.status.uploadError = false; //视频是否上传失败
                // $scope.status.transcoding = false; //
                $scope.status.canSaveMaterial = false;
                $scope.status.progress = '0';
            });
        }

        $scope.deletevideo = function () {
            $scope.status.progress = 0; //上传进度清零
            $scope.status.uploadSuccess = false; //视频是否上传成功
            $scope.status.uploading = false;
            // $scope.status.uploadError = false; //视频是否上传失败
            // $scope.status.transcoding = false; //视频正在转码
            // $scope.status.transcodSuccess = false; //视屏是否转码成功
            // $scope.status.transcodError = false; //视频是否转码失败
            $scope.status.videoUrl = ''; //视屏的播放地址
            $scope.status.videoIds = []; //清空上传的视屏的id
            if ($scope.uploadObj) { // 存在uploadObj在清楚
                $scope.uploadObj.removeFile($scope.onuploadList[0]);
            }
            $scope.onuploadList = [];
        };
        /**
         * [openVideo description] 打开视频播放
         * @return {[type]} [description]
         */
        // $scope.playVideo = function () {
        //     if (!$scope.status.transcodSuccess) {
        //         modalDialog.alertType('', '视频正在处理中，请等待处理结束', 'warning', 'confirm');
        //         return;
        //     } else {
        //     }
        // };

        /**
         * [initList description] 初始化表单数据
         * @return {[type]} [description]
         */
        function initList() {
            var deffer = $q.defer();
            if (!!$stateParams.id) {
                $scope.status.progress = '100';
                // $scope.status.transcodSuccess = true;
                $scope.status.uploadSuccess = true;
                $scope.status.progress = 100;
                getDraftInfo().then(function (result) {
                    $scope.list = result.data;
                    $scope.list.firstClassic = result.firstClassic;
                    $scope.list.secondClassic = result.secondClassic;
                    persinalLibraryService.getVideoDetail(result.videoUrlList[0].audioVideoId).then(
                        (res) => {
                            result.videoUrlList[0].url = res || result.videoUrlList[0].url;
                            $scope.status.videoUrl = result.videoUrlList[0].url;
                        }
                    );
                    $timeout(function () {
                        var video = result.videoUrlList[0];
                        $scope.list.yunshiIds = [];
                        $scope.list.yunshiIds.push({
                            type: 3,
                            originName: video.title,
                            uploadName: video.fileName,
                            uploadPath: video.url,
                            thumbImg: video.thumbImg,
                            audioVideoId: video.audioVideoId
                        });
                        $scope.list.yunshiIds = JSON.stringify($scope.list.yunshiIds);
                    });
                    deffer.resolve();
                });
            } else {
                // $scope.status.isNew = true;
                deffer.resolve();
            }
            return deffer.promise;
        }
        /**
         * [getDraftInfo description] 查询稿件信息
         * @return {[type]} [description]
         */
        function getDraftInfo() {
            var deffer = $q.defer();
            var params = {
                id: $stateParams.id
            };
            $scope.loadingPromise = httpService.http('/mcnww/web/article/findById.do', params, 'get').then(function (result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        }
        /**
         * [loadUeditor description] 加载编辑器
         * @return {[type]} [description]
         */
        function loadUeditor() {
            var $ueditor = $('<ueditor></ueditor>');
            var $ueditorLocation = $element.find('ueditorLocation');
            LazyLoad.js(['./static/ueditor/ueditor.config.js?v=11.4', './static/ueditor/ueditor.all.js?v=11.4'], function () {
                $ueditor.attr({
                    type: 'video',
                    list: 'list',
                    'has-content': 'status.hasContent',
                    versionid: $scope.list.id,
                    infullscreen: 'status.infullscreen',
                    placeholder: '请输入文章正文'
                });
                $ueditor = $compile($ueditor)($scope);
                $ueditorLocation.append($ueditor);
            });
        }
        /**
         * [save description] 保存或发布文章
         * @return {[type]} [description]
         */
        $scope.save = function (ispub) {
            examineVideo().then(function () {
                return saveContent()
            }).then(function () {
                return validator();
            }).then(function () {
                saveArticle(ispub);
            });
        };
        /**
         * [saveArticle description] 保存文章
         * @return {[type]} [description]
         */
        function saveArticle(ispub) {
            // var channelData = getSelectChannel();
            var d = $scope.list;
            var boo = false;
            var params = {
                articleTitle: d.articleTitle,
                articleContent: d.articleHtmlCon,
                articleHtmlCon: d.articleHtmlCon,
                // channels: JSON.stringify(channelData),
                articleType: '2',
                // videos: JSON.stringify($scope.status.videoIds),
                DOCWORDSCOUNT: d.DOCWORDSCOUNT,
                bPub: boo,
                yunshiIds: d.yunshiIds,
                firstClassId: d.firstClassId,
                secondClassId: d.secondClassId,
                remark: d.remark
            };
            //新建的时候不传id
            if (d.id != 0) {
                params.id = d.id;
            }
            $scope.loadingPromise = httpService.http('/mcnww/web/article/addEdit.do', params, 'post').then(function (data) {
                if (data && data.success) {
                    var newId = data.data.id;
                    $scope.list.id = newId;
                    reFreshListPage();
                    ueditorService.saveToLocal(newId);
                    if (!ispub) {
                        modalDialog.success(
                            '保存成功',
                            'success',
                            false,
                            function () {
                                $state.go(
                                    'editvideo',
                                    {
                                        id: newId,
                                        type: 7
                                    },
                                    {
                                        reload: 'editvideo'
                                    }
                                );
                            },
                            function () { },
                            '',
                            'left0'
                        );
                    } else {
                        var vparams = {
                            ids: newId
                        };
                        $scope.loadingPromise = httpService.http('/mcnww/web/article/contribute.do', vparams, 'get', true).then(function (data) {
                            modalDialog.success('投稿成功', 'success', false, function () { window.close(); }, function () { }, 2000, 'left0');
                        },function (data) {
                            $state.go('editvideo', {
                                id: newId,
                                type: 7
                            }, {
                                reload: 'editvideo'
                            });
                            if (data.message === '稿件中存在未转码完成的视频!') {
                                modalDialog.alertType('投稿失败', '视频正在转码中，请耐心等待，稍后再试。', 'error', false);
                            } else {
                                modalDialog.alertType("错误", data.message, "error", false);
                            }
                        });
                    }
                }
            });
        }

        /**
         * [registerVideo description]是上传视频后注册视频
         * @param   {[obj]}  file   [file description]上传后的文件
         * @param   {[obj]}  user   [user description]当前用户登录信息
         * @param   {[str]}  token  [token description]用户token
         * @return  {[promise]}         [return description]promise
         */
        function registerVideo(file) {
            var defer = $q.defer();
            var params = {
                tempUrl: file.path,
                tenantId: '3',
                userId: 'AAAABQAMdGVzdEB0cnMuY29tABx0ZXN0QHRycy5jb20sMywxNTc4ODg4Nzg1Nzk4AAAALzAtAhUAkYbTEsbpfqXrVG9_psU_CpwT5lkCFFw1Gq_Hk3yYL89R0fi3yw9f8koN',
                videoName: file.name
            };
            httpService.http('/transfer/aav/video/uploadByTempUrl', params, 'post').then(
                function (data) {
                    defer.resolve(data);
                },
                error => {
                    defer.reject(error);
                }
            );
            return defer.promise;
        }
        /**
         * [examineVideo description] 检查视频
         * @return  {[type]}  [return description]
         */
        function examineVideo() {
            var defer = $q.defer();
            // if (!$scope.status.uploadSuccess) {
            //     modalDialog.alertType('', '视频正在上传中，请等待上传结束', 'warning', 'confirm');
            //     defer.reject();
            // }
            // if (!$scope.status.transcodSuccess) {
            //     modalDialog.alertType('', '视频正在处理中，请等待处理结束', 'warning', 'confirm');
            //     defer.reject();
            // }
            if ($scope.status.uploading) {
                modalDialog.alertType('', '视频正在上传中，请等待上传结束再进行保存', 'warning', 'confirm');
                defer.reject();
            }
            else {
                defer.resolve();
            }
            return defer.promise;
        }
        /**
         * [saveContent description] 保存正文
         * @return {[type]} [description]
         */
        function saveContent() {
            var deffer = $q.defer();
            ueditorService.saveContent($scope.list);
            if ($scope.list.articleHtmlCon === '') {
                $timeout(function () {
                    //表单校验手动触发
                    // $scope.videoForm.content.$error.content = true;
                    // $scope.videoForm.content.$valid = false;
                    // $scope.videoForm.content.$invalid = true;
                    // $scope.videoForm.$error.content = [$scope.videoForm.content];
                    $scope.videoForm.$valid = false;
                    $scope.videoForm.$invalid = true;
                    deffer.resolve();
                });
            } else {
                deffer.resolve();
            }
            return deffer.promise;
        }
        /**
         * [validator description] 表单校验
         * @return {[type]} [description]
         */
        function validator() {
            var deffer = $q.defer();
            $validation
                .validate($scope.videoForm)
                .success(function () {
                    deffer.resolve();
                })
                .error(function (result) {
                    angular.invalidPosition($scope.videoForm, $element);
                });
            return deffer.promise;
        }
        /**
         * [getPubWayInfo description] 获取渠道
         * @return {[type]} [description]
         */
        function getPubWayInfo() {
            var deffer = $q.defer();
            httpService.http('/mcnww/web/channel/querySignChnlsAndTags.do', '', 'get').then(function (data) {
                $scope.channels = data.channels;
                $scope.$broadcast('channels', $scope.channels);
                deffer.resolve();
            });
            return deffer.promise;
        }
        /**
         * [reFreshList description] 刷新列表页
         * @return {[type]} [description]
         */
        function reFreshListPage() {
            localStorageService.set('refresh', Math.random());
        }

        /**
         * [reSelectClassify description] 选中分类
         * @return {[type]} [description]
         */
        function reSelectClassify() {
            var flag = true;
            for (var i = 0; i < $scope.status.classicListOneLevel.length; i++) {
                if ($scope.status.classicListOneLevel[i].id == $scope.list.firstClassId) {
                    flag = false;
                    $scope.status.selectedOneLevel = angular.copy($scope.status.classicListOneLevel[i]);
                    break;
                }
            }
            if (flag) {
                $scope.status.selectedOneLevel = angular.copy($scope.status.classicListOneLevel[0]);
            }
            flag = true;
            getClassicListTwoLevel().then(function () {
                for (var j = 0; j < $scope.status.classicListTwoLevel.length; j++) {
                    if ($scope.status.classicListTwoLevel[j].id == $scope.list.secondClassId) {
                        flag = false;
                        $scope.status.selectedTwoLevel = angular.copy($scope.status.classicListTwoLevel[j]);
                        break;
                    }
                }
                if (flag) {
                    $scope.status.selectedTwoLevel = $scope.status.classicListTwoLeve === undefined ? $scope.status.selectedTwoLevel : $scope.status.classicListOneLevel.unshift({ name: '请选择' });
                    $scope.status.selectedTwoLevel = angular.copy($scope.status.classicListOneLevel[0]);
                }
            });
        }
        /**
         * [getClassicList description] 获取一级分类
         * @return {[type]} [description]
         */
        function getClassicListOneLevel() {
            var deffer = $q.defer();
            httpService.http('/mcnww/web/classic/classicList.do', '', 'get').then(function (data) {
                $scope.status.classicListOneLevel = (function (data) {
                    for (var i in data.data) {
                        data.data[i].name = data.data[i].departName;
                    }
                    return data.data;
                })(data);
                $scope.status.classicListOneLevel.unshift({ name: '请选择' });
                $scope.status.selectedOneLevel = $scope.status.classicListOneLevel[0];
                // $scope.list.firstClassId = $scope.status.selectedOneLevel.id;
                deffer.resolve();
            });
            return deffer.promise;
        }
        $scope.getClassicListTwoLevel = getClassicListTwoLevel;
        /**
         * [getClassicListTwoLevel description] 获取二级分类
         * @return {[type]} [description]
         */
        function getClassicListTwoLevel() {
            var deffer = $q.defer();
            if (!$scope.status.selectedOneLevel) {
                deffer.resolve();
                return deffer.promise;
            }
            var params = {
                id: $scope.status.selectedOneLevel.id
            };
            httpService.http('/mcnww/web/classic/classicList.do', params, 'get').then(function (data) {
                $scope.status.classicListTwoLevel = (function (data) {
                    for (var i in data.sList) {
                        data.sList[i].name = data.sList[i].departName;
                    }
                    return data.sList;
                })(data);
                // $scope.status.selectedTwoLevel = $scope.status.classicListTwoLevel.length === 0? {name: '请选择'} : angular.copy($scope.status.classicListTwoLevel[0]);
                $scope.status.classicListTwoLevel.unshift({ name: '请选择' });
                $scope.status.selectedTwoLevel = angular.copy($scope.status.classicListTwoLevel[0]);
                $scope.list.secondClassId = angular.isDefined($scope.list.secondClassId) ? $scope.list.secondClassId : undefined;
                $scope.list.firstClassId = $scope.status.selectedOneLevel.id;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [getTwoLevelid 获取二级分类id]
         * @return {[type]} [description]
         */
        $scope.getTwoLevelid = function () {
            $scope.list.secondClassId = $scope.status.selectedTwoLevel.id;
        };
    }
]);
